import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/java-logo.svg'


const _hoisted_1 = { class: "installation-guide-token-view container" }
const _hoisted_2 = {
  class: "alert alert-dismissible alert-success",
  role: "alert"
}
const _hoisted_3 = { class: "alert__icon" }
const _hoisted_4 = {
  class: "btn-close align-items-center",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_5 = { class: "container installation-guide-container d-flex flex-row py-3 mb-5" }
const _hoisted_6 = { class: "description-to-install-java ms-3" }
const _hoisted_7 = { class: "d-flex-flex-row text-start only-desk" }
const _hoisted_8 = {
  class: "text-start",
  href: "https://www.java.com/pt-BR/download/",
  target: "_blank"
}
const _hoisted_9 = { class: "d-flex-flex-row text-start only-mob" }
const _hoisted_10 = {
  class: "text-start",
  type: "button",
  "data-bs-target": "#modal-only-desktop",
  "data-bs-toggle": "modal"
}
const _hoisted_11 = { class: "card-guides row gap-4" }
const _hoisted_12 = { class: "col card" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "btn btn-outline-primary",
  type: "button",
  href: "/ManualEmissaoA3.pdf",
  target: "_blank"
}
const _hoisted_15 = { class: "col card" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  class: "btn btn-outline-primary",
  type: "button",
  href: "/ManualEmissaoA3.pdf",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ModalTokenA3 = _resolveComponent("ModalTokenA3")!
  const _component_ModalOnlyUseOnDesktop = _resolveComponent("ModalOnlyUseOnDesktop")!
  const _component_ModalSmartCard = _resolveComponent("ModalSmartCard")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, { "class-name": "py-0" }),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, { name: "shield" })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "alert__content" }, " Parabéns! Sua solicitação foi enviada com sucesso! Verifique seu e-mail. ", -1)),
      _createElementVNode("button", _hoisted_4, [
        _createVNode(_component_Icon, { name: "xmark" })
      ])
    ], 512), [
      [_vShow, _ctx.getSolicitation.cdSolicitacao !== '']
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("h1", { class: "text-start" }, " Guia de instalação do Certificado Digital em mídia ", -1)),
    _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-start only-desk" }, " Veja como instalar seu Certificado Digital ", -1)),
    _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "text-start only-mob" }, " Agora vamos instalar seu Certificado Digital! ", -1)),
    _createElementVNode("div", _hoisted_5, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "img-logo-java" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo do java"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("p", null, " Antes de fazer o download do driver e do emissor, você precisa ter o Java instalado e atualizado em seu computador. ", -1)),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Clique aqui para fazer o download ", -1)),
            _createVNode(_component_Icon, {
              class: "ms-2",
              name: "download"
            })
          ])
        ]),
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _cache[10] || (_cache[10] = _createTextVNode("Clique aqui para fazer o download ")),
            _createVNode(_component_Icon, {
              class: "ms-2",
              name: "download"
            })
          ])
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createStaticVNode("<h4 class=\"text-start mb-5\" data-v-39e1cda6> Escolha abaixo qual o tipo de Certificado você deseja instalar </h4><div class=\"token-guides d-flex flex-row only-desk\" data-v-39e1cda6><div class=\"token-guides__title d-flex flex-row\" data-v-39e1cda6><span class=\"only-desk\" data-v-39e1cda6>Certificados Tipo A3</span><div class=\"divider-token-large mx-4\" data-v-39e1cda6></div></div></div>", 2)),
    _createElementVNode("div", _hoisted_11, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "only-mob text-start d-flex flex-row" }, [
        _createElementVNode("span", { class: "span-mob text-start" }, "Certificados Tipo A3"),
        _createElementVNode("div", { class: "divider-mob" })
      ], -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "img-box-desktop my-3",
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverTokenA3 = true)),
          onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hoverTokenA3 = false))
        }, [
          _createElementVNode("img", {
            src: _ctx.tokenA3Anima,
            alt: "Ilustração de um Token A3",
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hoverTokenA3 = true)),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverTokenA3 = false))
          }, null, 40, _hoisted_13)
        ], 32),
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "fw-bold" }, "A3 com Token", -1)),
        _createElementVNode("a", _hoisted_14, [
          _createVNode(_component_Icon, {
            class: "me-2",
            name: "up-right-from-square"
          }),
          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
        ]),
        _createVNode(_component_ModalTokenA3),
        _createVNode(_component_ModalOnlyUseOnDesktop, null, {
          message: _withCtx(() => _cache[14] || (_cache[14] = [
            _createElementVNode("h3", null, [
              _createTextVNode(" A instalação de um Certificado Digital através de Token ou Smartcard, deve ser feita em um "),
              _createElementVNode("strong", null, "computador ou notebook.")
            ], -1)
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "img-box-desktop my-3",
          onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hoverSmartCard = true)),
          onMouseout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hoverSmartCard = false))
        }, [
          _createElementVNode("img", {
            class: "mt-4",
            src: _ctx.smartcardAnima,
            alt: "",
            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoverSmartCard = true)),
            onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hoverSmartCard = false))
          }, null, 40, _hoisted_16)
        ], 32),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "fw-bold" }, "A3 com Smartcard", -1)),
        _createElementVNode("a", _hoisted_17, [
          _createVNode(_component_Icon, {
            class: "me-2",
            name: "up-right-from-square"
          }),
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
        ]),
        _createVNode(_component_ModalSmartCard),
        _createVNode(_component_ModalOnlyUseOnDesktop, null, {
          message: _withCtx(() => _cache[17] || (_cache[17] = [
            _createElementVNode("h3", null, [
              _createTextVNode(" A instalação de um Certificado Digital através de Token ou Smartcard, deve ser feita em um "),
              _createElementVNode("strong", null, "computador ou notebook.")
            ], -1)
          ])),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Contact)
  ]))
}